import { TrainingSession } from "@/features/training/model/Training/TrainingSession";

import { UserSummary } from "@/model/User/UserSummary";

export class TrainingCourse {
	Id: number;
	Name: string;
	Description: string;
	Duration: TrainingCourseDuration;
	CourseManager: UserSummary;
	Attachments: FileUpload[];
	Sessions: TrainingSession[];
	FolderId: number | null;
	GroupsWithCompetencyRequirement: GroupsWithCompetencyRequirement[];
}

interface GroupsWithCompetencyRequirement {
	Id: number;
	Name: string;
}

export enum TrainingCourseDuration {
	OneYear = "OneYear",
	TwoYears = "TwoYears",
	ThreeYears = "ThreeYears",
	EndOfYear = "EndOfYear",
	NoExpiryDate = "NoExpiryDate",
	Custom = "Custom",
}

export class FileUpload {
	Id: number;
	Filename: string;
	UrlPath: string;
}

export class TrainingCourseRequest {
	Name: string;
	Description: string | null;
	Duration: TrainingCourseDuration;
	CourseManagerId: number;
	Attachments: FileUpload[];
	NewAttachment: File | null;
	FolderId: number | null;
	GroupsWithCompetencyRequirement: number[];
}

export class EditTrainingCourseFormValues {
	request: TrainingCourseRequest;
	courseId: number;
}
